module.exports = __webpack_public_path__ + "img/bedroom-bookcases-cabinets.0e0c021.jpg";